// extracted by mini-css-extract-plugin
export default {"tabletMinViewport":"768px","desktopMinViewport":"1024px","smallScreenHeight":"970px","title":"MDyLSt","secondarySubtitle":"Hy_6ot","subtitle":"BQKy9q"};